import useStateMachineWrapper from "../helpers/useStateMachineWrapper";

const PaginationButton = ({mode, enabled = true, page, action}) => {
    const {actions, state} = useStateMachineWrapper();

    let classes = [enabled ? 'cursor-pointer' : 'cursor-not-allowed'];

    if(mode === 'back' || !enabled) {
        classes.push('text-gray');
        if(enabled) {
            classes.push('hover:text-gray-600');
        }
    } else {
        classes.push('text-yellow');
        if(enabled) {
            classes.push('hover:text-yellow-600');
        }
    }

    /*
    let colorClass = 'text-gray hover:text-gray-600';

    if(mode === 'next' && enabled) {
        colorClass = 'text-yellow hover:text-yellow-600';
    }

    let enabledClass = enabled ? 'cursor-pointer' : 'cursor-not-allowed';
    */

    const onClick = async () => {
        if(!enabled) {
            return;
        }

        let shouldProceed = true;
        try {
            shouldProceed = await action();
        } catch(e) {
            //
        }
        if(shouldProceed === false) {
            return;
        }

        if(page != null && typeof page === 'string') {
            /*if(['address-unavailable','address-available','intro'].includes(page) && mode === 'back'){
                const res = sessionStorage.getItem('bfAdd');        
                const obj = res ? JSON.parse(res) : null;        
                if(obj && obj.referrer !== null){
                    const ref = obj.referrer;
                    obj.referrer = null;
                    const jsonAddress = JSON.stringify(obj);
                    sessionStorage.setItem('bfAdd', jsonAddress);
                    window.location.assign(ref);
                    return;
                }
            }*/

            actions.setPage(page);
        }
    };

    return (
    <div className={`${classes.join(' ')}`} onClick={onClick}>
        {mode === 'back' && (
            <div className="btn-bf-nav" style={{ backgroundColor: 'currentColor', color: 'white', padding: '0.5em 1em', borderRadius: '4px' }}>
                Back
            </div>
        )}

        {mode === 'next' && (
            <div className="btn-bf-nav" style={{ backgroundColor: 'currentColor', color: 'white', padding: '0.5em 1em', borderRadius: '4px' }}>
                Next
            </div>
        )}
    </div>
);
};

export default PaginationButton;
